module.exports = __webpack_public_path__ + "img/kundal.abef1fc0.svg";